<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

// Compact read-only summary of a follow-up send window, shown in list rows.
// The caller guards rendering with v-if on `window.enabled`.
const props = defineProps({
  window: {
    type: Object,
    default: () => ({}),
  },
});

const { t } = useI18n();

const days = computed(() =>
  (props.window?.days || []).map(Number).sort((a, b) => a - b)
);

const shortLabels = computed(() => ({
  0: t('FOLLOW_UP_SEND_WINDOW.WEEKDAYS.SUN'),
  1: t('FOLLOW_UP_SEND_WINDOW.WEEKDAYS.MON'),
  2: t('FOLLOW_UP_SEND_WINDOW.WEEKDAYS.TUE'),
  3: t('FOLLOW_UP_SEND_WINDOW.WEEKDAYS.WED'),
  4: t('FOLLOW_UP_SEND_WINDOW.WEEKDAYS.THU'),
  5: t('FOLLOW_UP_SEND_WINDOW.WEEKDAYS.FRI'),
  6: t('FOLLOW_UP_SEND_WINDOW.WEEKDAYS.SAT'),
}));

const daysSummary = computed(() => {
  const selected = days.value;
  if (selected.length === 7) return t('FOLLOW_UP_SEND_WINDOW.BADGE_ALL_DAYS');
  if (selected.join(',') === '1,2,3,4,5') {
    return t('FOLLOW_UP_SEND_WINDOW.BADGE_WEEKDAYS');
  }
  return selected.map(day => shortLabels.value[day]).join(', ');
});

const label = computed(
  () => `${props.window.start}–${props.window.end} · ${daysSummary.value}`
);
</script>

<template>
  <span
    class="inline-flex items-center gap-1 px-2 h-5 rounded text-[10px] font-medium bg-n-alpha-2 text-n-slate-11"
  >
    <span class="i-lucide-clock size-3" aria-hidden="true" />
    {{ label }}
  </span>
</template>
